export default "__VITE_ASSET__t6yk9EX8__"